export default function Hierarchical_Clustering() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Hierarchical_Clustering</h1>
      <p>Content for Hierarchical_Clustering goes here.</p>
    </div>
  );
}